import { CloudOff } from 'lucide-react'

import { EmptyState } from '@/components/ui'

/** Shown by online screens while offline or signed out; the till itself keeps working. */
export const NeedsConnection = () => (
  <EmptyState icon={CloudOff} title="Needs a connection" className="flex-1">
    This screen reads the server. Selling and everything on the device keep working; it fills in once the device is online
    and signed in.
  </EmptyState>
)
